import { SuitSymbol } from '../common/SuitSymbol';
import { formatBidToken } from '../../utils/formatBidToken';

/**
 * Render a built call token (e.g. `1D`, `Pass`, `X`, `1NT`) with graphical suit symbols per the
 * Suit Symbol Display standard. Contract bids show the level followed by the coloured suit glyph
 * (NT stays textual); Pass/Double/Redouble use the shared `formatBidToken` display forms.
 */
export function CallText({ call }: { call: string }) {
  const upper = call.trim().toUpperCase();
  const suitMatch = upper.match(/^([1-7])(C|D|H|S)$/);
  if (suitMatch) {
    return (
      <span>
        {suitMatch[1]}
        <SuitSymbol suit={suitMatch[2] as 'C' | 'D' | 'H' | 'S'} />
      </span>
    );
  }
  if (/^[1-7]NT$/.test(upper)) return <span>{upper}</span>;
  return <span>{formatBidToken(call)}</span>;
}
